var map = {
	"./en_CA": [
		857894,
		546
	],
	"./en_CA.json": [
		857894,
		546
	],
	"./en_US": [
		133242,
		294
	],
	"./en_US.json": [
		133242,
		294
	],
	"./fr_CA": [
		274739,
		285
	],
	"./fr_CA.json": [
		274739,
		285
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 829747;
module.exports = webpackAsyncContext;